/**
 * Guide step 2: course overview.
 */
import React, { useMemo } from "react";
import { Icon } from "@iconify/react";
import { Box } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";

import { useAsterController } from "context";
import { VText, VImage } from "form";
import { getFormatDate } from "utils/date";

/**
 * Shows course overview copy for onboarding.
 */
const Guide2 = () => {
  const { t, i18n } = useTranslation("common");

  const { courseId } = useParams();

  const [controller] = useAsterController();
  const { courses } = controller;

  const currCourse = useMemo(() => (courses.data || []).find((v) => v.id === courseId) || {}, [courseId, courses.data]);

  return (
    <Box className="flex flex-col md:flex-row justify-center items-center w-full max-w-screen-xl mx-auto gap-10 md:py-10">
      <Box className="flex justify-center items-center md:w-6/12 w-full">
        <VImage src={`${process.env.REACT_APP_S3_ASSET_ENDPOINT}/v2-assets/app/guide/guide2.svg`} className="w-full max-w-sm" draggable={false} />
      </Box>
      <Box className="flex flex-col md:w-6/12 w-full">
        <VText className="text-4xl">{t("Your highlights not to be missed")}</VText>

        <Box className="px-6 pt-6 pb-0">
          <Box className="mt-5 overflow-y-auto v-light-scrollbar max-h-64">
            <Box className="flex">
              <Box className="w-8 h-8 rounded flex items-center justify-center">
                <Icon className="color-primary text-2xl border-2 border-solid border-gray-300 dark:border-gray-500 rounded-full" icon="bi:record-circle" />
              </Box>
              <Box className="flex-1 break-all mx-2 mb-4 relative">
                <VText className="font-bold">{t("Start of training")}</VText>
                <VText color="secondary" className="text-sm mt-2" div>
                  {getFormatDate(currCourse.enroll_start, i18n.language)}
                </VText>
                <Box className="w-0.5 h-full bg-primary absolute -left-6 top-6" />
              </Box>
            </Box>
            <Box className="flex">
              <Box className="w-8 h-8 rounded flex items-center justify-center">
                <Icon className="color-primary text-2xl border-2 border-solid border-gray-300 dark:border-gray-500 rounded-full" icon="bi:record-circle" />
              </Box>
              <Box className="flex-1 break-all mx-2 mb-4 relative">
                <VText className="font-bold">{t("End of training")}</VText>
                <VText color="secondary" className="text-sm mt-2" div>
                  {getFormatDate(currCourse.enroll_end, i18n.language)}
                </VText>
              </Box>
            </Box>
          </Box>
        </Box>

        <VText className="text-4xl text-orange-600">{t("Virtual classes")} *</VText>
        <br />
        <VText className="text-2xl">{t("The slots for the virtual classes* will be sent to you by e-mail so that you can exchange with the training expert and the other participants.")}</VText>
        <VText className="text-2xl">{t("Only available if your training offer includes vistoconterence.")}</VText>
      </Box>
    </Box>
  );
};

export default Guide2;
